module.exports = __webpack_public_path__ + "img/8.c5c79616.jpg";